import { NPCIdleScheduler } from './npc-idle-scheduler';
import type { IndividualIdleClip } from './individual-idle-assets';
import { meshyNpcClip, meshyNpcDuration, type MeshyNpcClip, type MeshyNpcModel } from './meshy-npc-clips';
import type { HeroAnimationFacing } from '@/modules/game-domain/render-snapshot';
const CLIPS:Record<IndividualIdleClip,MeshyNpcClip>={breathing_idle:'breathing',catwalk_idle:'catwalk',idle:'warrior-idle',bored:'bored',looking_around:'looking-around'};
/** Service actors stay planted: finish calm loops, play one gesture, then return to calm. */
export class ServiceNpcAnimation {
  private readonly scheduler:NPCIdleScheduler;
  constructor(actorKey:string,model:MeshyNpcModel) {
    this.scheduler=new NPCIdleScheduler(actorKey,clip=>meshyNpcDuration(meshyNpcClip(model,CLIPS[clip],'south-east')));
  }
  sample(now:number,facing:HeroAnimationFacing,ready:(clip:MeshyNpcClip,facing:HeroAnimationFacing)=>boolean):{clip:MeshyNpcClip;elapsedMs:number} {
    const view=this.scheduler.sample(now,clip=>ready(CLIPS[clip],facing));
    return {clip:CLIPS[view.clip],elapsedMs:view.elapsedMs};
  }
}
